<template>
 <div>
     <social-sharing class="sharing" 
                    url="https://routine.oyen.de"
                    title="Routine pwa"
                    description="Manage your daily tasks quickly"
                    quote="Routine pwa quote"
                    hashtags="routine, pwa, tasks"
                    inline-template>
  <div>
      
      <network class="email" network="email">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#fff" d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
        </svg>
      </network>
       <network class="facebook" network="facebook">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="#fff" d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" />
</svg>
      </network>
      <network class="linkedin" network="linkedin">
       <svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="#fff" d="M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3A2,2 0 0,1 7,5A2,2 0 0,1 5,7A2,2 0 0,1 3,5A2,2 0 0,1 5,3Z" />
</svg>
      </network>
      <network class="twitter" network="twitter">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="#fff" d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" />
</svg>
      </network>
      <network class="whatsapp" network="whatsapp">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="#fff" d="M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
</svg>
      </network>
  </div>
</social-sharing>
 <div class="center-me" style="position: absolute; bottom: 22%; left: 50%; transform: translateX(-50%)">
                     <v-btn class="white" @click="$router.go(-1)">Back</v-btn>
                  </div>
 </div>
</template>

<script>
import Vue from 'vue'
import SocialSharing from 'vue-social-sharing';
Vue.use(SocialSharing);

export default {
    name: 'sharing',
    data () {
        return {

        }
    }
}
</script>

<style>
.sharing {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    position: absolute;
    top: 44%;
    transform: translate(-50%, -50%);
    left: 50%;
}
.sharing > span {
    border-radius: 4px;
    width: 170px;
    height: 40px;
    margin: 0 0 30px 0;
    font-size: 1rem;
    color: #fff !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
}
.email {
    background: #8E8E8E;
}
.facebook {
    background: #3b5998;
}
.linkedin {
    background: #0077B5;
}
.twitter {
    background: #1DA1F2;
}
.whatsapp {
    background: #25d366;
}
</style>